export const searchTypes = {
  federal: {
    selectVlaue: "Federal",
    value: "Federal",
    due: "ResponseDeadLine",
    posted: "PostedDate",
    title: "Title",
    type: "Type",
    summary: "Summary",
  },
  sled: {
    selectValue: "SLED",
    value: "State, Local and Education",
    due: "dueDate",
    posted: "startDate",
    title: "title",
    type: "type",
    summary: "summary",
  },
  grant: {
    selectValue: "Grants",
    value: "Federal Grants",
    due: "responseDate",
    posted: "postingDate",
    title: "opportunityTitle",
    type: "oppStatus",
    summary: "summary",
  },
  sbir: {
    selectValue: "SBIR/STTRs",
    value: "SBIR/STTRs",
    due: "closeDate",
    posted: "releaseDate",
    title: "title",
    type: "program",
    summary: "summary",
  },
};
